var Y = Object.defineProperty, Z = Object.defineProperties;
var k = Object.getOwnPropertyDescriptors;
var j = Object.getOwnPropertySymbols;
var M = Object.prototype.hasOwnProperty, O = Object.prototype.propertyIsEnumerable;
var I = (e, s, t) => s in e ? Y(e, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[s] = t, a = (e, s) => {
  for (var t in s || (s = {}))
    M.call(s, t) && I(e, t, s[t]);
  if (j)
    for (var t of j(s))
      O.call(s, t) && I(e, t, s[t]);
  return e;
}, x = (e, s) => Z(e, k(s));
var B = (e, s) => {
  var t = {};
  for (var r in e)
    M.call(e, r) && s.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && j)
    for (var r of j(e))
      s.indexOf(r) < 0 && O.call(e, r) && (t[r] = e[r]);
  return t;
};
import { jsx as c, jsxs as _, Fragment as ee } from "react/jsx-runtime";
import { forwardRef as se } from "react";
import { c as te } from "../../create-vars-resolver-Bzbn9G-G.js";
import { b as E, n as H, o as C, I as J, f as K, u as L, l as Q, B as S, c as oe } from "../../factory-ueRxoNOV.js";
import { u as re } from "../../use-styles-DToiHEa6.js";
import { c as ne } from "../../create-safe-context-DqDyoPVE.js";
import { g as p, a as U } from "../../get-base-value-DBR0fUhH.js";
import { b as T } from "../../get-size-Bc1Pz5yf.js";
const [W, X] = ne(
  "Grid component was not found in tree"
), V = (e, s) => e === "content" ? "auto" : e === "auto" ? "0rem" : e ? `${100 / (s / e)}%` : void 0, b = (e, s, t) => t || e === "auto" ? "100%" : e === "content" ? "unset" : V(e, s), z = (e, s) => {
  if (e)
    return e === "auto" || s ? "1" : "auto";
}, A = (e, s) => e === 0 ? "0" : e ? `${100 / (s / e)}%` : void 0;
function ie({ span: e, order: s, offset: t, selector: r }) {
  var h;
  const v = E(), o = X(), u = o.breakpoints || v.breakpoints, m = p(e) === void 0 ? 12 : p(e), f = H({
    "--col-order": (h = p(s)) == null ? void 0 : h.toString(),
    "--col-flex-grow": z(m, o.grow),
    "--col-flex-basis": V(m, o.columns),
    "--col-width": m === "content" ? "auto" : void 0,
    "--col-max-width": b(m, o.columns, o.grow),
    "--col-offset": A(p(t), o.columns)
  }), l = C(u).reduce(
    (n, i) => {
      var w;
      return n[i] || (n[i] = {}), typeof s == "object" && s[i] !== void 0 && (n[i]["--col-order"] = (w = s[i]) == null ? void 0 : w.toString()), typeof e == "object" && e[i] !== void 0 && (n[i]["--col-flex-grow"] = z(e[i], o.grow), n[i]["--col-flex-basis"] = V(e[i], o.columns), n[i]["--col-width"] = e[i] === "content" ? "auto" : void 0, n[i]["--col-max-width"] = b(
        e[i],
        o.columns,
        o.grow
      )), typeof t == "object" && t[i] !== void 0 && (n[i]["--col-offset"] = A(t[i], o.columns)), n;
    },
    {}
  ), G = U(C(l), u).filter(
    (n) => C(l[n.value]).length > 0
  ).map((n) => ({
    query: o.type === "container" ? `mantine-grid (min-width: ${u[n.value]})` : `(min-width: ${u[n.value]})`,
    styles: l[n.value]
  }));
  return /* @__PURE__ */ c(
    J,
    {
      styles: f,
      media: o.type === "container" ? void 0 : G,
      container: o.type === "container" ? G : void 0,
      selector: r
    }
  );
}
var P = { container: "m_8478a6da", root: "m_410352e9", inner: "m_dee7bd2f", col: "m_96bdd299" };
const le = {
  span: 12
}, q = K((e, s) => {
  const n = L("GridCol", le, e), { classNames: r, className: v, style: o, styles: u, vars: g, span: m, order: f, offset: l } = n, d = B(n, ["classNames", "className", "style", "styles", "vars", "span", "order", "offset"]), G = X(), h = Q();
  return /* @__PURE__ */ _(ee, { children: [
    /* @__PURE__ */ c(
      ie,
      {
        selector: `.${h}`,
        span: m,
        order: f,
        offset: l
      }
    ),
    /* @__PURE__ */ c(
      S,
      a(a({
        ref: s
      }, G.getStyles("col", {
        className: oe(v, h),
        style: o,
        classNames: r,
        styles: u
      })), d)
    )
  ] });
});
q.classes = P;
q.displayName = "@mantine/core/GridCol";
function D({ gutter: e, selector: s, breakpoints: t, type: r }) {
  const v = E(), o = t || v.breakpoints, u = H({
    "--grid-gutter": T(p(e))
  }), g = C(o).reduce(
    (l, d) => (l[d] || (l[d] = {}), typeof e == "object" && e[d] !== void 0 && (l[d]["--grid-gutter"] = T(e[d])), l),
    {}
  ), f = U(C(g), o).filter(
    (l) => C(g[l.value]).length > 0
  ).map((l) => ({
    query: r === "container" ? `mantine-grid (min-width: ${o[l.value]})` : `(min-width: ${o[l.value]})`,
    styles: g[l.value]
  }));
  return /* @__PURE__ */ c(
    J,
    {
      styles: u,
      media: r === "container" ? void 0 : f,
      container: r === "container" ? f : void 0,
      selector: s
    }
  );
}
const ae = {
  gutter: "md",
  grow: !1,
  columns: 12
}, ce = te((e, { justify: s, align: t, overflow: r }) => ({
  root: {
    "--grid-justify": s,
    "--grid-align": t,
    "--grid-overflow": r
  }
})), N = K((e, s) => {
  const t = L("Grid", ae, e), F = t, {
    classNames: r,
    className: v,
    style: o,
    styles: u,
    unstyled: g,
    vars: m,
    grow: f,
    gutter: l,
    columns: d,
    align: G,
    justify: h,
    children: n,
    breakpoints: i,
    type: w
  } = F, R = B(F, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "grow",
    "gutter",
    "columns",
    "align",
    "justify",
    "children",
    "breakpoints",
    "type"
  ]), y = re({
    name: "Grid",
    classes: P,
    props: t,
    className: v,
    style: o,
    classNames: r,
    styles: u,
    unstyled: g,
    vars: m,
    varsResolver: ce
  }), $ = Q();
  return w === "container" && i ? /* @__PURE__ */ _(W, { value: { getStyles: y, grow: f, columns: d || 12, breakpoints: i, type: w }, children: [
    /* @__PURE__ */ c(D, a({ selector: `.${$}` }, t)),
    /* @__PURE__ */ c("div", x(a({}, y("container")), { children: /* @__PURE__ */ c(S, x(a(a({ ref: s }, y("root", { className: $ })), R), { children: /* @__PURE__ */ c("div", x(a({}, y("inner")), { children: n })) })) }))
  ] }) : /* @__PURE__ */ _(W, { value: { getStyles: y, grow: f, columns: d || 12, breakpoints: i, type: w }, children: [
    /* @__PURE__ */ c(D, a({ selector: `.${$}` }, t)),
    /* @__PURE__ */ c(S, x(a(a({ ref: s }, y("root", { className: $ })), R), { children: /* @__PURE__ */ c("div", x(a({}, y("inner")), { children: n })) }))
  ] });
});
N.classes = P;
N.displayName = "@mantine/core/Grid";
N.Col = q;
const de = Object.assign(
  se((v, r) => {
    var o = v, {
      "data-plum-id": e,
      className: s
    } = o, t = B(o, [
      "data-plum-id",
      "className"
    ]);
    return /* @__PURE__ */ c(
      N,
      a({
        ref: r,
        className: s,
        "data-plum-id": e
      }, t)
    );
  }),
  { Col: N.Col }
);
de.displayName = "Grid";
export {
  de as Grid
};
